


















































































import FlightClass from "@/store/entities/flight/flightClass";
import { Component, Vue } from "vue-property-decorator";
import AddFlightClass from "./modals/addFlightClass.vue";

@Component({
  components: { AddFlightClass },
})
export default class FlightClasses extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  flightClasses: FlightClass[] = [];

  created() {
    this.getFlightClasses();

    (this.headers = [
      { text: "ID", value: "id" },
      { text: "İsim", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      // this.mockData=[
      //   {
      //     code: 'X',
      //     name: 'ECONOMY',
      //   },

      // ]

      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Tanımlamalar", disabled: true },
        { text: "Uçuş Sınıfları", disabled: true },
      ]);
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getFlightClasses() {
    await this.$store.dispatch({
      type: "flightClass/getFlightClasses",
    });

    this.flightClasses = this.$store.state.flightClass.list;
  }

  editFlightClass(item) {
    this.$store.state.flightClass.editFlightClass = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.flightClass.editFlightClass = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getFlightClasses();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
